export const galleryLayouts = {
    HORIZONTAL: 'h',
    VERTICAL: 'v',
}

export const galleryTypes = {
    PAID: 'paid_galleries',
    UNLOCKED: 'unlocked_galleries',
    FAVORITE: 'favorite_galleries',
}

export const checkinTabs = {
    BUYABLE: 'Buyable',
    BOUGHT: 'Bought',
    FAVORITE: 'Favorite'
}

export const cartActions = {
    ADD: 'add',
    REMOVE: 'remove'
}

export const mediaTypes = {
    PHOTO: 'photo',
    VIDEO: 'video'
}

export const mediaQuality = {
    SD: 'SD',
    HD: 'HD',
    AUTO: 'AUTO'
}


export const ctaPosition = {
    TOP: 't',
    BOTTOM: 'b'
}

export const paginationType = {
    NUMBER: 'number',
    INFINITE: 'infinite'
}

export const servingType = {
    DISABLED: 'd',
    STANDARD: 's',
    MAX_RESOLUTION: 'm',
    ORIGINAL: 'o'

}